import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import {
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Checkbox,
  CardActions,
} from '@material-ui/core';
import messages from 'containers/PreOpeningPage/messages';
import { translate } from 'containers/services/translate';
import { Container } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import OpposingPartyRecapComponent from 'containers/PreOpeningPage/OpposingParty/OpposingPartyRecapComponent';
import { PAGES } from 'routes';
import routesHelper from 'containers/services/routes-helper';
import { get, isEmpty } from 'lodash';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';
import { CheckBoxWrapper } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import OpposingPartyDrawer from 'containers/PreOpeningPage/OpposingParty/OpposingPartyDrawer';
import { Listings } from 'containers/AppContainer/typings';
import { CLAIM_STATUS, EMPTY_VEHICULE } from 'containers/data-structure';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { getOpposingParty } from 'containers/PreOpeningPage/OpposingParty/utils';
import AddOpposingPartyDrawer from 'containers/PreOpeningPage/OpposingParty/AddOpposingPartyDrawer';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import AddOpposingParty from 'containers/PreOpeningPage/OpposingParty/AddOpposingParty';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { removeDeletedItems } from 'services/utils';
export interface OpposingPartyRecapContainerProps {
  intl: IntlShape;
  claimToPreopen: any;
  storedClaimToPreopen: any;
  isManager?: boolean;
  isRecapPage?: boolean;
  listings: Listings;
  setClaimRecap?: Function;
  requestUpdateVehicleInfo?: Function;
  policyInfo?: { sagis: {} };
  requestCreateVehicle?: Function;
  requestValidateVehicle?: Function;
  isLawyer?: boolean;
  isRejected?: boolean;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  claimId?: number;
  isCourtManager?: boolean;
  sagisOpposingParties: any;
  isLockedPage?: boolean;
  requestClaimRecap?: Function;
  isConsultation?: boolean;
}

const OpposingPartyRecapContainer: React.FC<OpposingPartyRecapContainerProps> = ({
  claimToPreopen,
  storedClaimToPreopen,
  isManager,
  isRecapPage,
  listings,
  ...props
}): JSX.Element => {
  const isRejected =
    get(storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.REJECTED;
  const isPending =
    get(storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.PENDING ||
    get(storedClaimToPreopen, 'claim.status') ===
      CLAIM_STATUS.PENDING_INFO_MODIFICATION ||
    get(storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.PENDING_APPROVAL;
  const isValidated =
    get(storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.VALIDATED;
  const isValidatedCorpo =
    get(storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.PENDING_APPROVAL;
  const claim = !isEmpty(storedClaimToPreopen)
    ? { ...storedClaimToPreopen }
    : claimToPreopen;
  const [opposingPartyData, setOpposingPartyData] = useState(
    isManager || isRecapPage
      ? getOpposingParty(props.policyInfo, claim.vehicules)
      : get(claim, 'opposingParty.vehicules', []),
  );
  const isPreOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISPREOPENMANAGER,
  );

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);

  const [vehiculeIndex, setVehiculeIndex] = useState(0);
  const [selectedVehicule, setSelectedVehicule] = useState({
    ...EMPTY_VEHICULE,
  });
  useEffect(() => {
    if (isManager || isRecapPage) {
      setOpposingPartyData(getOpposingParty(props.policyInfo, claim.vehicules));
    } else {
      setOpposingPartyData(get(claim, 'opposingParty.vehicules', []));
    }
  }, [!storedClaimToPreopen]);
  const updateByProfile = () => {
    if (userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)) {
      setIsAddDrawerOpen(true);
    } else if (userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)) {
      routesHelper.pushTo(PAGES.OPENING_CLAIM)();
    } else if (isPreOpeningManager) {
      routesHelper.pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
        isUsageOpening: get(props, 'location.state.isUsageOpening', false),
      })();
    } else {
      routesHelper.pushTo(PAGES.PREOPENING)();
    }
  };

  const handleToggleDrawer = (index: number, isCancel: boolean = false) => {
    setIsDrawerOpen(!isDrawerOpen);
    setVehiculeIndex(index);
    props.requestClaimRecap &&
      isCancel &&
      props.requestClaimRecap(props.claimId);
  };

  const handleToggleAddDrawer = (index: number) => {
    setIsAddDrawerOpen(!isAddDrawerOpen);
  };
  const shouldDisplayEditButton =
    ((!isManager && !isRecapPage) ||
      (!props.isLockedPage &&
        userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        ))) &&
    !props.isLockedPage &&
    !isValidatedCorpo &&
    (props.isCourtManager
      ? featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)
      : true);

  const shouldDisplayAddOpposingPartyBloc =
    (props.isLawyer && isRejected && !props.isLockedPage) ||
    (props.isCourtManager &&
      featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)) ||
    (userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
      ((featureService.hasFeature(FEATURES.UPDATE_CLAIM_OPENING_MANAGER) &&
        isPending) ||
        (featureService.hasFeature(
          FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
        ) &&
          isValidated)) &&
      !props.isLockedPage &&
      !isValidatedCorpo);

  const handleDeleteOpposingParty = (v: any) => () => {
    const foundVehicule = opposingPartyData.find(
      (el: any) => el.registrationNumber === v.registrationNumber,
    );
    if (foundVehicule) foundVehicule.isDeleted = true;
    const newOpposingPartyData = opposingPartyData.filter((el: Vehicule) => {
      if (!v.id) return el.registrationNumber !== v.registrationNumber;
      return el.id !== v.id;
    });
    setOpposingPartyData([...newOpposingPartyData, foundVehicule]);
    props.setDataClaimToUpdate &&
      props.setDataClaimToUpdate({
        ...props.dataClaimToUpdate,
        vehicules: [...newOpposingPartyData, foundVehicule],
      });
    if (props.setClaimRecap) {
      props.setClaimRecap({
        ...claim,
        vehicules: [...newOpposingPartyData, foundVehicule],
      });
    }
  };
  const [toggleOpen, setToggleOpen] = React.useState<boolean>(false);
  const [renderSubForm] = React.useState<boolean>(true);
  useDeepCompareEffect(() => {
    props.setDataClaimToUpdate &&
      props.setDataClaimToUpdate({
        ...props.dataClaimToUpdate,
        vehicules: [
          ...opposingPartyData.map((el: any) => {
            return { ...el, claimId: props.claimId };
          }),
        ],
      });
    if (props.setClaimRecap) {
      props.setClaimRecap({
        ...claim,
        vehicules: [
          ...opposingPartyData.map((el: any) => {
            return { ...el, claimId: props.claimId };
          }),
        ],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opposingPartyData]);

  return (
    <Container className="container">
      <Card>
        <CardContent>
          <CardActions className="opposingparty-bloc-header">
            <Typography className="titleRecap">
              {translate({ ...messages.opposingPartyCardTitle }, props)}
            </Typography>
            {shouldDisplayEditButton && !props.isConsultation && (
              <SecondaryButton
                onClick={updateByProfile}
                title={translate({ ...messages.addOpposingParty }, props)}
              />
            )}
          </CardActions>
          <CheckBoxWrapper>
            <Typography className="typography">
              {translate(messages.formQuestion, props)}
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked
                  checkedIcon={<CheckCircle />}
                  icon={<RadioButtonUnchecked />}
                  disabled
                />
              }
              label={
                !isEmpty(opposingPartyData)
                  ? translate(messages.yes, props)
                  : translate(messages.no, props)
              }
            />
          </CheckBoxWrapper>
          <div className="vehiculeContainer">
            {removeDeletedItems(opposingPartyData).map(
              (el: Vehicule, index: number) => (
                <OpposingPartyRecapComponent
                  vehicule={el}
                  claim={claim}
                  index={index}
                  isManager={isManager}
                  handleToggleDrawer={() => handleToggleDrawer(index)}
                  setCurrentVehicule={setSelectedVehicule}
                  listings={listings}
                  policyInfo={props.policyInfo}
                  requestValidateVehicle={props.requestValidateVehicle}
                  isLawyer={props.isLawyer}
                  isRejected={isRejected}
                  handleDeleteOpposingParty={handleDeleteOpposingParty}
                  isCourtManager={props.isCourtManager}
                  sagisOpposingParties={props.sagisOpposingParties}
                  isPending={isPending}
                  isValidated={isValidated}
                  isValidatedCorpo={isValidatedCorpo}
                  isConsultation={props.isConsultation}
                />
              ),
            )}
            {shouldDisplayAddOpposingPartyBloc && (
              <AddOpposingParty
                listings={listings}
                claimToPreopen={claimToPreopen}
                toggleOpen={toggleOpen}
                setToggleOpen={setToggleOpen}
                renderSubForm={renderSubForm}
                isForDrawer={false}
                setClaimToPreopen={() => {}}
                opposingPartyData={opposingPartyData}
                setOpposingPartyData={setOpposingPartyData}
              />
            )}
          </div>
        </CardContent>
      </Card>
      {isDrawerOpen && (
        <OpposingPartyDrawer
          open={isDrawerOpen}
          handleToggleDrawer={handleToggleDrawer}
          vehicule={selectedVehicule}
          listings={listings}
          vehiculeIndex={vehiculeIndex}
          data={claim}
          setVehicule={setSelectedVehicule}
          policyInfo={props.policyInfo}
          setClaimRecap={props.setClaimRecap}
          requestUpdateVehicleInfo={props.requestUpdateVehicleInfo}
          setOpposingPartyData={setOpposingPartyData}
          opposingPartyData={opposingPartyData}
          setDataClaimToUpdate={props.setDataClaimToUpdate}
          dataClaimToUpdate={props.dataClaimToUpdate}
          sagisOpposingParties={props.sagisOpposingParties}
        />
      )}
      {isAddDrawerOpen && (
        <AddOpposingPartyDrawer
          listings={listings}
          open={isAddDrawerOpen}
          handleToggleDrawer={handleToggleAddDrawer}
          setClaimRecap={props.setClaimRecap}
          data={{
            ...claim,
            opposingParty: {
              hasMaterialDammage: !isEmpty(opposingPartyData),
              vehicules: claim.vehicules,
              newVehicles: claim?.opposingParty?.newVehicles
                ? claim.opposingParty.newVehicles
                : [],
            },
          }}
          requestCreateVehicle={props.requestCreateVehicle}
          handleAddOpposingParty={() => {}}
          sagisOpposingParties={props.sagisOpposingParties}
        />
      )}
    </Container>
  );
};

export default injectIntl(OpposingPartyRecapContainer);
